// extracted by mini-css-extract-plugin
module.exports = {"IconActions":"IconActions__3Cx4C","IconActions--hasSpacing":"IconActions--hasSpacing__3dd7x"};